export function useSettings() {
  const { locale } = useI18n()
  const oscar = useOscarClient(locale.value)
  const authStore = useAuthStore()
  const { settings } = storeToRefs(authStore)

  return useAsyncData('settings', async () => {
    const res = await oscar.getSettings()
    settings.value = res.data

    return res.data
  })
}
